import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { provide } from 'vue';
import { Composer, useI18n } from 'vue-i18n';
import marketCategoriesConfig from '@/configs/market-categories.config';
import marketEnhancementConfig from '@/configs/market-enhancement.config';
import { MarketCategoriesConfigKey, MarketEnhancementConfigKey, TranslateKey } from '@/composables/use-inject';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMarketplaceProvider',
  setup(__props) {

const i18n: Composer = useI18n();

provide(TranslateKey, i18n.t);

provide(MarketCategoriesConfigKey, marketCategoriesConfig);
provide(MarketEnhancementConfigKey, marketEnhancementConfig);

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})